var config = {};
config.AppKey = '3355B39D-5172-4761-9427-215BD5CBEF98';
config.PersonaAppKey = '3355B39D-5172-4761-9427-215BD5CBEF99';
config.MexicoAppKey = 'A1C7072C-B77B-4B10-9B24-2920F8BE5DE5';
config.serviceURL = 'http://ccxapidev.arifleet.com/api/'; ////'http://ccxapidev.arifleet.com/api/';//  'http://localhost:60980/api/'; //'http://mtlwdvintxiis01:92/api/'; //'http://192.168.150.217:82/api/';
config.personaServiceURL = 'http://ccxapidev.arifleet.com/api/';//'http://localhost:60980/api/';// 'http://cciapcpersonaapidev.arifleet.com/api/'; //'http://localhost:52969/api/';
config.logServiceURL = 'http://cciapilogdev.arifleet.com/api/';// 'http://ccxapidev.arifleet.com/api/';// 'http://localhost:60980/api/';//http://mtlwdvintxiis01:92/api/';
config.shopViewRefreshFrequencyInMinutes = 10;
config.sessionExpirationTimeInMinutes = 30; /*session expiration time in minutes*/
config.taxName = 'Standard';
config.searchDelay = 400;
config.throttledSaveStateInSeconds = 3;
config.recentServicePageSize = 5;
config.repairHistoryPageSize = 25;
config.supplierSiteLink = "http://intisldev.arifleet.com/SUPPLIERS/default.aspx?referral=APC";
config.enableVMSLogging = false;
config.reCaptchaKey = '6LcEbFkeAAAAACJVyz0pCQ_W9WI7VpYkYKzfE6Q1';
config.AccmanApiUrl = 'https://api.dev.holman.solutions/accmanV2/';
config.accidentAssignmentsViewRefreshFrequencyInMinutes = 10;
config.accmanConcurentImageUpload = 5;
config.defaultTaxLimit = .15;
config.overrideTaxLimit = .25;
config.vendorServiceUrl = 'https://api.dev.holman.solutions/vendor-service/';
config.verificationEmailResendTimeInMinutes = 1;
config.hiveRouterUrl = "https://api.dev.holman.solutions/holmanHiveRouter/";
config.fleetVendorRouterUrl = "https://api.dev.holman.com/holmanFleetVendorRouter/";
config.graphQLClientName = "PartnerConnect";
config.graphQLClientVersion = "1.0.0-ReplacedByOd";
config.currentVersionCheckTimeInMinutes = 15; // Time in minutes to check for version update
config.singleUseEnrollmentCodeEnabled = true;
config.ssoApplications = [
    "FCASECUREAUTH",
    "LESSCHWABSECUREAUTH",    
    "NavistarSSO",
    "FIRESTONESECUREAUTH",
];
/*
//These are the keys for the different environments for recaptcha
config.reCaptchaKeyLocal='6Lcia1keAAAAAH0seHi8t5JKeHsVo37F6ZdDO0pc';
config.reCaptchaKeyDevelopment='6LcEbFkeAAAAACJVyz0pCQ_W9WI7VpYkYKzfE6Q1';
*/
config.holmanPartnerConnectRedirectUrl = "https://hpcdev.holman.com";
config.showHolmanRedirectScreen = "disabled"; // enabled / disabled
config.version = "1.0.0-ReplacedByOd";
config.SAPIntegrationEnabled = "{SAPIntegrationEnabled}";
module.exports = config;